import React from "react";
import { FiGithub, FiLinkedin} from "react-icons/fi";
import { BsWhatsapp } from "react-icons/bs";

const Social = () => {
    return (
        <div className="home__social">
            <a href="https://github.com/ashkanazimei" className="home__social-icon" target="_blank" rel="noreferrer noopener">
                <FiGithub />
            </a>
            <a href="https://www.linkedin.com/in/ashkan-azimi-010712365/" className="home__social-icon" target="_blank" rel="noreferrer noopener">
                <FiLinkedin />
            </a>
            {/* آیکون واتس‌اپ */}
            <a 
                href="https://wa.me/989375188740" 
                className="home__social-icon whatsapp-icon" 
                target="_blank" 
                rel="noreferrer noopener"
                title="Chat on WhatsApp"
            >
                <BsWhatsapp />
            </a>
        </div> 
    ); 
}

export default Social;